import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { BudgetState } from 'src/app/budget/budget.state';

import { BudgetDetailModalComponent } from '../../../budget/budget-detail-modal/budget-detail-modal.component';
import Budget from '../../../models/Budget';

@Component({
    selector: 'app-pill-budget',
    templateUrl: './pill-budget.component.html',
    styleUrls: ['./pill-budget.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PillBudgetComponent implements OnInit, OnDestroy {
    @Input() budget: Budget;
    @Input() budgetUuid: string;
    @Input() fallbackLabel: string;
    @Input() selectedDate: Date;
    @Select(BudgetState.Budgets) budgets$: Observable<Budget[]>;
    budgets: any = [];
    attentionLevel: number;
    totalSpend: number;
    actualCost: number;
    checkAttentionLevel = Budget.checkAttentionLevel;
    getTotalSpend = Budget.getTotalSpend;
    private subscriptions = new Subscription();

    constructor(private modalService: NgbModal, private store: Store) {}

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.budgetUuid) {
            this.budget = this.budgets.find((b) => b.uuid == this.budgetUuid);
        }
        this.updateBudgetStats();
    }

    ngOnInit(): void {
        if (this.budgetUuid) {
            this.subscriptions.add(
                this.budgets$.subscribe((budgets) => {
                    this.budgets = budgets || [];
                    if (this.budgetUuid && !this.budget) {
                        this.budget = this.budgets.find((b) => b.uuid == this.budgetUuid);
                        if (!this.budget) {
                            console.warn('[PillBudget] Budget not found in store for linked object', {
                                budgetUuid: this.budgetUuid,
                                fallbackLabel: this.fallbackLabel || null,
                            });
                        }
                    }
                    this.updateBudgetStats();
                }),
            );
        }

        this.updateBudgetStats();
    }

    openBudgetDetailModel() {
        if (!this.budget?.uuid) {
            return;
        }

        const modalRef = this.modalService.open(BudgetDetailModalComponent, {
            windowClass: 'modal-pane',
            animation: false,
        });
        modalRef.componentInstance.budgetId = this.budget.uuid;
    }

    private updateBudgetStats(): void {
        if (!this.budget) {
            this.attentionLevel = 0;
            this.totalSpend = 0;
            this.actualCost = 0;
            return;
        }

        this.attentionLevel = this.checkAttentionLevel(this.budget);
        this.totalSpend = this.getTotalSpend(this.budget);
        this.actualCost = this.budget.budgetExpenditures?.reduce((acc, exp) => acc + exp.cost, 0) || 0;
    }
}
